export default __webpack_public_path__ + "static/bell-background-d4be4485b3145f3c6d1b29ed9d28eae1.png";